import { render } from "./NovncConsole.vue?vue&type=template&id=5deaeb46&scoped=true"
import script from "./NovncConsole.vue?vue&type=script&lang=js"
export * from "./NovncConsole.vue?vue&type=script&lang=js"

import "./NovncConsole.vue?vue&type=style&index=0&id=5deaeb46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deaeb46"]])

export default __exports__